import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createStore } from "redux";
import { Provider } from "react-redux";
import reducer from "./reducer/reducer";
const store = createStore(reducer);

window.renderreactP = (reactProjectId, history) => {
  ReactDOM.render(
    <Provider store={store}>
      <App history={history} />
    </Provider>,
    document.getElementById(reactProjectId)
  );
  serviceWorker.unregister();
};

window.unmountreactP = (reactProjectId) => {
  ReactDOM.unmountComponentAtNode(document.getElementById(reactProjectId));
};

if (!document.getElementById("reactP-reactProject")) {
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById("root")
  );
  serviceWorker.unregister();
}
